import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function PlansSection() {
  const {
    t
  } = useLanguage();
  const plans = [{
    icon: '🥉',
    name: t('plans.name1'),
    idealFor: t('plans.ideal1'),
    price: t('plans.price1'),
    highlight: false
  }, {
    icon: '🥈',
    name: t('plans.name2'),
    idealFor: t('plans.ideal2'),
    price: t('plans.price2'),
    highlight: false
  }, {
    icon: '🥇',
    name: t('plans.name3'),
    idealFor: t('plans.ideal3'),
    price: t('plans.price3'),
    highlight: true
  }];
  return <section className="bg-brand-alt py-16 md:py-24" data-id="element-122">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy" data-id="element-125">
            {t('plans.title')}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-126">
          {plans.map((plan, index) => <motion.div key={index} className={`bg-white rounded-2xl p-8 shadow-lg flex flex-col items-center text-center relative ${plan.highlight ? 'border-2 border-brand-primary transform md:-translate-y-4' : 'border border-gray-100'}`} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} data-id="element-127">
              {plan.highlight && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-primary text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-128">
                  {t('plans.popular')}
                </div>}
              <div className="text-5xl mb-4" data-id="element-129">{plan.icon}</div>
              <h3 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-130">
                {plan.name}
              </h3>
              <p className="text-brand-text mb-8 flex-grow" data-id="element-131">{plan.idealFor}</p>
              <div className="w-full pt-6 border-t border-gray-100" data-id="element-132">
                <p className="text-xl font-bold text-brand-primary" data-id="element-133">
                  {plan.price}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div className="text-center max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-134">
          <p className="text-xl text-brand-text font-medium mb-8" data-id="element-135">
            {t('plans.bottom')}
          </p>
          <a href="https://wa.me/15514017684?text=Hola,%20quiero%20saber%20qué%20plan%20es%20el%20ideal%20para%20mi%20negocio" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full sm:w-auto bg-brand-accent text-brand-navy font-bold text-lg py-4 px-8 rounded-lg shadow-lg hover:bg-yellow-300 hover:scale-105 transition-all duration-300 min-h-[56px]" data-id="element-136">
            {t('plans.cta')}
          </a>
        </motion.div>
      </div>
    </section>;
}